import { useMutation } from "react-query";
import { useStoreCRMCreate } from "../stores/useStoreCRMCreate";
import { createCRMRecords } from "../apis/crm";

export const useCRMCreateRecords = ({ onSuccess, onError, onStream } = {}) => {
  const { addChunkInCRMBulkCreateData } = useStoreCRMCreate();

  return useMutation(
    ({ data, configId, options }) =>
      createCRMRecords({
        data,
        configId,
        options,
        onStream: (chunk) => {
          console.log("crmRecords in create chunk raw", chunk);
          let data = JSON.parse(JSON.stringify(chunk));
          data.data = chunk?.data ? [{ ...chunk?.data }] : [];
          console.log("crmRecords in create chunk modified", data);
          // Internal store update
          addChunkInCRMBulkCreateData(data);
          // Custom consumer stream handler
          onStream?.(data);
        },
      }),
    {
      onSuccess: (data, variables, context) => {
        console.log("on success bulk create", data);
        // Internal post-success logic (if needed here)
        // Then user-provided callback
        onSuccess?.(data, variables, context);
      },
      onError: (error, variables, context) => {
        console.error("❌ Bulk create stream error:", error);
        onError?.(error, variables, context);
      },
    }
  );
};
